// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Message, MessageT, verifyMessage } from "../ln2/message";

/**
 * A single exclusion group: a set of enum values within one
 * MessageCategory that are mutually exclusive.
 *
 * Example for door states (all within Usage category):
 *   members: [FrontDoorOpened(14), FrontDoorOpening(10), FrontDoorClosed(15)]
 *
 * At runtime, receiving any member evicts all other members from state.
 */
export class OneHotExclusionEntry implements flatbuffers.IUnpackableObject<OneHotExclusionEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OneHotExclusionEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOneHotExclusionEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: OneHotExclusionEntry,
  ): OneHotExclusionEntry {
    return (obj || new OneHotExclusionEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsOneHotExclusionEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: OneHotExclusionEntry,
  ): OneHotExclusionEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OneHotExclusionEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * The enum values (within the parent group's category) that form
   * a mutually exclusive set. Uses uint16 to accommodate all category
   * enums (Status has 438 values, Usage has 176).
   */
  members(index: number, obj?: Message): Message | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Message()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  membersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startOneHotExclusionEntry(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMembers(builder: flatbuffers.Builder, membersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, membersOffset, 0);
  }

  static createMembersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMembersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endOneHotExclusionEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // members
    return offset;
  }

  static createOneHotExclusionEntry(
    builder: flatbuffers.Builder,
    membersOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    OneHotExclusionEntry.startOneHotExclusionEntry(builder);
    OneHotExclusionEntry.addMembers(builder, membersOffset);
    return OneHotExclusionEntry.endOneHotExclusionEntry(builder);
  }

  unpack(): OneHotExclusionEntryT {
    return new OneHotExclusionEntryT(
      this.bb!.createObjList<Message, MessageT>(this.members.bind(this), this.membersLength()),
    );
  }

  unpackTo(_o: OneHotExclusionEntryT): void {
    _o.members = this.bb!.createObjList<Message, MessageT>(
      this.members.bind(this),
      this.membersLength(),
    );
  }

  unpackFields(...fields: string[]): OneHotExclusionEntryT {
    const t = new OneHotExclusionEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("members")) {
      t.members = this.bb!.createObjList<Message, MessageT>(
        this.members.bind(this),
        this.membersLength(),
      );
    }
    return t;
  }
}

export class OneHotExclusionEntryT implements flatbuffers.IGeneratedObject {
  constructor(public members: MessageT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.members === null || this.members === undefined) {
      throw new Error('Required field "members" is not set');
    }
    const members = OneHotExclusionEntry.createMembersVector(
      builder,
      builder.createObjectOffsetList(this.members),
    );

    return OneHotExclusionEntry.createOneHotExclusionEntry(builder, members);
  }

  clone(): OneHotExclusionEntryT {
    const obj = new OneHotExclusionEntryT();
    obj.members = this.members.map((e) => e.clone());
    return obj;
  }

  equals(other: OneHotExclusionEntryT): boolean {
    if (this.members.length !== other.members.length) return false;
    for (let i = 0; i < this.members.length; i++) {
      const a = this.members[i];
      const b = other.members[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyOneHotExclusionEntry(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMessage);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "members");
  } finally {
    verifier.popDepth();
  }
}
